<template>
  <div>
    <OptionsList :active="active" :select="select" data-label="size" :options="options" />

    <div class="relative mt-6">
      <div class="absolute inset-0 flex items-center">
        <div class="w-full border border-t-1 border-grey-lighter"></div>
      </div>
      <div class="relative flex justify-center">
        <span class="px-8 text-base uppercase bg-white text-black"> OR </span>
      </div>
    </div>

    <DimensionInputRenderless :onSet="resetSizes">
      <template v-slot="{ dimension, set, submit }">
        <div>
          <div class="mt-6 pb-6">
            <div class="mb-4">
              Width
              <span class="font-light">(cm)</span>
            </div>
            <div class="flex items-center space-x-8">
              <input
                :value="dimension.width.min"
                @input="set('width')"
                name="min"
                placeholder="Min"
                type="number"
                class="bg-grey-lighter p-6 w-full"
              />
              <input
                :value="dimension.width.max"
                @input="set('width')"
                name="max"
                type="number"
                placeholder="Max"
                class="bg-grey-lighter p-6 w-full"
              />
            </div>
          </div>

          <div class="mt-6 pb-6">
            <div class="mb-4">
              Height
              <span class="font-light">(cm)</span>
            </div>
            <div class="flex items-center space-x-8">
              <input
                :value="dimension.height.min"
                @input="set('height')"
                name="min"
                placeholder="Min"
                type="number"
                class="bg-grey-lighter p-6 w-full"
              />
              <input
                :value="dimension.height.max"
                @input="set('height')"
                name="max"
                type="number"
                placeholder="Max"
                class="bg-grey-lighter p-6 w-full"
              />
            </div>
          </div>
        </div>
      </template>
    </DimensionInputRenderless>
  </div>
</template>

<script setup>
import OptionsList from "@/pages/ListingsPage/filters/mobile/OptionsList.vue"
</script>

<script>
import { mapActions, mapState } from "vuex"
import ListingFilters from "@/lib/ListingFilters"
import DimensionInputRenderless from "@/components/Listing/DimensionInputRenderless"

export default {
  name: "SizeFilter",
  data() {
    return {
      orientationOptions: ListingFilters.orientations,
      options: ListingFilters.sizes,
      dimensionsTouched: false,
    }
  },
  methods: {
    select(size) {
      this.resetDimension()
      this.mergeFilter({
        sizes: this.active(size) ? this.sizes.filter((value) => value !== size) : [...this.sizes, size],
        height: [],
        width: [],
      })
    },
    resetSizes() {
      if (this.sizes.length > 0) {
        this.mergeFilter({
          sizes: [],
        })
      }
      this.dimensionsTouched = true
    },
    active(size) {
      return this.sizes.includes(size)
    },
    sizeGaAction(value) {
      return {
        "0-30": "small",
        "30-80": "medium",
        "80-150": "large",
        "150-300": "xlarge",
      }[value]
    },
    ...mapActions("filter", ["mergeFilter", "resetDimension", "mergeDimensions"]),
  },
  computed: {
    ...mapState("filter", {
      sizes: (state) => state.filters.sizes || [],
    }),
  },
  components: {
    DimensionInputRenderless,
  },
  beforeDestroy() {
    // Load listings only if dimensions are touched (not every close or show art button submit)
    if (this.dimensionsTouched) this.mergeDimensions()
  },
}
</script>
